module.exports = __webpack_public_path__ + "media/images/apple_pay-04030e66.svg";